__webpack_require__.p = "https://cdn.retailanalysis.cloud/ui-dev/2.30.0/";